var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择发货地址",
            visible: _vm.visible,
            width: "720px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            closed: _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "12px" } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.openAddressAdd },
                },
                [_vm._v("添加地址")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.addressLoading,
                  expression: "addressLoading",
                },
              ],
              staticStyle: { "min-height": "80px" },
            },
            [
              !_vm.addressLoading && _vm.addressList.length === 0
                ? _c("el-empty", { attrs: { description: "暂无常用地址" } })
                : _c(
                    "div",
                    { staticClass: "address-card-grid" },
                    _vm._l(_vm.addressList, function (addr) {
                      return _c(
                        "div",
                        {
                          key: addr.id,
                          staticClass: "address-select-card",
                          class: {
                            "is-selected": _vm.selectedAddressId === addr.id,
                          },
                          on: {
                            click: function ($event) {
                              _vm.selectedAddressId = addr.id
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "addr-card-body" },
                            [
                              _c("i", {
                                staticClass: "el-icon-location-outline",
                                staticStyle: {
                                  color: "#409EFF",
                                  "margin-right": "4px",
                                  "flex-shrink": "0",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "addr-card-text" }, [
                                _vm._v(_vm._s(_vm.fmtAddress(addr.address))),
                              ]),
                              _vm._v(" "),
                              addr.isDefault === 1
                                ? _c(
                                    "el-tag",
                                    {
                                      staticStyle: {
                                        "margin-left": "8px",
                                        "flex-shrink": "0",
                                      },
                                      attrs: { type: "success", size: "mini" },
                                    },
                                    [_vm._v("默认")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          addr.detailedAddress
                            ? _c("div", { staticClass: "addr-card-detail" }, [
                                _vm._v(_vm._s(addr.detailedAddress)),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "addr-card-user" }, [
                            _c("i", {
                              staticClass: "el-icon-user",
                              staticStyle: {
                                color: "#909399",
                                "margin-right": "4px",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(addr.name))]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-left": "12px",
                                  color: "#909399",
                                },
                              },
                              [_vm._v(_vm._s(addr.phone))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "addr-card-actions" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      size: "mini",
                                      icon: "el-icon-edit",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.editAddress(addr)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "#f56c6c" },
                                    attrs: {
                                      type: "text",
                                      size: "mini",
                                      icon: "el-icon-delete",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.deleteAddressItem(addr.id)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.selectedAddressId },
                  on: { click: _vm.confirmSelection },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editAddressId ? "编辑地址" : "添加地址",
            visible: _vm.addressAddVisible,
            width: "520px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addressAddVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.addressAddForm,
                "label-width": "80px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "联系人" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入联系人姓名" },
                    model: {
                      value: _vm.addressAddForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.addressAddForm, "name", $$v)
                      },
                      expression: "addressAddForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "联系电话" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入联系电话" },
                    model: {
                      value: _vm.addressAddForm.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.addressAddForm, "phone", $$v)
                      },
                      expression: "addressAddForm.phone",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "所在地区" } },
                [
                  _c("AddressCascader", {
                    model: {
                      value: _vm.addressAddForm.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.addressAddForm, "address", $$v)
                      },
                      expression: "addressAddForm.address",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "详细地址" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入街道、小区、门牌号等" },
                    model: {
                      value: _vm.addressAddForm.detailedAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.addressAddForm, "detailedAddress", $$v)
                      },
                      expression: "addressAddForm.detailedAddress",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "设为默认" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.addressAddForm.isDefault,
                      callback: function ($$v) {
                        _vm.$set(_vm.addressAddForm, "isDefault", $$v)
                      },
                      expression: "addressAddForm.isDefault",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addressAddVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.addressAddLoading },
                  on: { click: _vm.submitAddressAdd },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }